import { Box, CircularProgress, Typography } from '@mui/material';

export function LoadingSkeleton() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <CircularProgress color="primary" />
      <Typography variant="body2" sx={{
        color: "text.secondary"
      }}>
        Loading workspace...
      </Typography>
    </Box>
  );
}

export default LoadingSkeleton;
